import { render } from "./index.vue?vue&type=template&id=159937f6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=159937f6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\zwkj\\cdzblue\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159937f6"]])

export default __exports__